import React from 'react';
import {
  Pane,
  Avatar,
  majorScale,
  LogOutIcon,
  IconButton,
  Popover,
  Menu,
  Position,
  Text,
  Strong,
  MenuIcon,
  CogIcon,
} from 'evergreen-ui';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Link as ReactRouterLink } from 'react-router-dom';
import { api } from '../../services/api';
import NotificationsMenu from './notifications';

const Navbar = ({ onChangeDrawer }) => {
  const currentUser = useSelector((state) => state.authentication.user);

  return (
    <Pane
      is="header"
      width="100%"
      height="64px"
      paddingX="18px"
      borderBottom="1px solid #edeff5"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      top="0"
      background="white">
      <Pane display="flex" alignItems="center">
        <IconButton icon={MenuIcon} onClick={onChangeDrawer} appearance="minimal" />
      </Pane>

      <Pane display="flex" alignItems="center">
        {/* Menus */}
        <NotificationsMenu />
        {/* Profile */}
        <ProfileMenu currentUser={currentUser} />
      </Pane>
    </Pane>
  );
};

const ProfileMenu = ({ currentUser }) => {
  const logout = async () => {
    await api.users.logout();
    window.location.reload();
  };

  return (
    <Popover
      position={Position.BOTTOM_LEFT}
      content={(
        <Menu>
          <Menu.Group>
            <Pane
              paddingX={majorScale(2)}
              paddingY={majorScale(1)}
              display="flex"
              justifyContent="center"
              alignItems="center">
              <Avatar name={currentUser && currentUser.name} size={48} />
              <Pane marginLeft={majorScale(2)}>
                <Pane>
                  <Strong>{currentUser && currentUser.name}</Strong>
                </Pane>
                <Pane>
                  <Text>{currentUser && currentUser.email}</Text>
                </Pane>
              </Pane>
            </Pane>
          </Menu.Group>
          <Menu.Divider />
          <Menu.Group>
            <Menu.Item is={ReactRouterLink} to="/user/settings" icon={CogIcon}>My settings</Menu.Item>
            <Menu.Item icon={LogOutIcon} onSelect={logout}>Logout</Menu.Item>
          </Menu.Group>
        </Menu>
      )}>
      <Avatar name={currentUser && currentUser.name} size={40} cursor="pointer" />
    </Popover>
  );
};

Navbar.propTypes = {
  onChangeDrawer: PropTypes.func,
};

ProfileMenu.propTypes = {
  currentUser: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
  }),
};

ProfileMenu.defaultProps = {
  currentUser: null,
};

export default Navbar;
